import { getUsersUrl, getRosterUrl } from "../config/Config";
import { getRequest, patchRequest, putRequest } from "./ServiceHelper";

export class UserService {
  static getUsers = (startRange, endRange) => {
    const param = {};
    if (startRange && endRange) {
      param.range_start = startRange;
      param.range_end = endRange;
    }
    return getRequest(getUsersUrl(), param);
  };

  static #patchUser = (param) => {
    return patchRequest(getUsersUrl() + "/", param);
  };

  // static setUserPermissions = (canvasId, permissions) => {
  //   return this.#patchUser({ canvas_id: canvasId, permissions: permissions });
  // };

  // static setUserRole(canvasId, roleId) {
  //   return this.#patchUser({ canvas_id: canvasId, role_id: roleId });
  // }

  static getUserById = (userId) => {
    return getRequest(getUsersUrl() + "/" + userId);
  };

  // static setAcSubjects(canvasId, acSubjects) {
  //   return this.#patchUser({ canvas_id: canvasId, ac_subjects: acSubjects });
  // }

  static setAllUserProperties(
    canvasId,
    roleId,
    acSubjects = null,
    permissions = null
  ) {
    const params = { canvas_id: canvasId, role_id: roleId };
    if (acSubjects) {
      params.ac_subjects = acSubjects;
    }
    if (permissions) {
      params.permissions = permissions;
    }
    return this.#patchUser(params);
  }

  static getRoster(contextId) {
    return getRequest(getRosterUrl(contextId));
  }

  static setCopiedOffering = (offeringDdlId, copied) => {
    return putRequest(getUsersUrl() + "/copied-offerings", {
      offering_ddl_id: offeringDdlId,
      copied: copied,
    });
  };
}
